import { useEffect, useRef } from 'react';

export const useDebounce = (callback: Function, delay = 300) => {
    const timeoutRef = useRef<number | null>(null);
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (...args: any[]) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // @ts-ignore
        timeoutRef.current = setTimeout(() => {
            callback(...args);
        }, delay);
    };
};
